module.exports = __webpack_public_path__ + "img/fenerbahce.a5d1fd59.png";